import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { LightModeOutlined, DarkModeOutlined } from '../icons';
import './ThemeToggle.css';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      className="theme-toggle-button"
      onClick={toggleTheme}
      aria-label={theme === 'dark' ? 'Ativar modo claro' : 'Ativar modo escuro'}
      title={theme === 'dark' ? 'Ativar modo claro' : 'Ativar modo escuro'}
    >
      {theme === 'dark' ? (
        <LightModeOutlined style={{ fontSize: 20 }} />
      ) : (
        <DarkModeOutlined style={{ fontSize: 20 }} />
      )}
    </button>
  );
};

export default ThemeToggle;
